export default __webpack_public_path__ + "static/media/zoho-negative.e51fb1d9.svg";